"use strict";

const BC_Document = function (EWS) {
    this.EWS = EWS;
    this.CurrentDocument = "";
};

BC_Document.prototype.CreateTinyMceDocument = function (dashboardItemID, ContentList, RefDocumentID, folder, type, title, callback, global) {
    const data = new FormData();
    data.append("Type", type);
    data.append("DashboardItemID", dashboardItemID);
    data.append("ContentList", JSON.stringify(ContentList));
    data.append("RefDocumentID", RefDocumentID);
    data.append("Global", global ? "True" : "False");

    if (!EC_Fmt.isNull(folder)) {
        data.append("Folder", folder);
    }

    if (!EC_Fmt.isNull(title)) {
        data.append("Title", title);
    }

    ECP.Dialog.ShowLoading();

    const me = this;
    ECP.Tools.Ajax("api?APICommand=Document_CreateDocument", {
        method: "POST",
        body: data
    }).then((response) => {
        response.json().then((result) => {
            ECP.Dialog.HideLoading();

            if (result.status === "success") {
                if (!EC_Fmt.isNull(callback)) {
                    callback(me, result.document, result.langDocumentId);
                }
            } else {
                ECP.Dialog.Alert(result.message);
            }
        }).catch((err) => {
            ECP.Dialog.HideLoading();
            throw err;
        });
    }).catch((err) => {
        ECP.Dialog.HideLoading();
        throw err;
    });
};

BC_Document.prototype.Create = function (folder, type, title, callback) {
    const data = new FormData();
    data.append("Type", type);

    if (!EC_Fmt.isNull(folder)) {
        data.append("Folder", folder);
    }

    if (!EC_Fmt.isNull(title)) {
        data.append("Title", title);
    }

    ECP.Dialog.ShowLoading();

    const me = this;

    ECP.Tools.Ajax("api?APICommand=Document_Create", {
        method: "POST",
        body: data
    }).then((response) => {
        response.json().then((result) => {
            ECP.Dialog.HideLoading();
            if (result.status === "success") {
                if (!EC_Fmt.isNull(callback)) {
                    callback(me, result.document.id, result.document);
                }
            } else {
                ECP.Dialog.Alert(result.message);
            }
        }).catch((err) => {
            ECP.Dialog.HideLoading();
            throw err;
        });
    }).catch((err) => {
        ECP.Dialog.HideLoading();
        throw err;
    });
};

BC_Document.prototype.Edit = function (documentID, callback, title, global) {
    const me = this;
    if (!EC_Fmt.isNull(documentID) && documentID > 0) {
        ECP.Tools.Ajax(`api?APICommand=Document_GetDocument&DocumentID=${documentID}&Global=${global ? "True" : "False"}`, {
            method: "GET"
        }).then((response) => {
            response.json().then((result) => {
                if (result.status === "success") {
                    switch (result.document.type) {
                        case "HTML":
                            let RefID = result.document.RefID;

                            if (!RefID) {
                                RefID = result.document.id;
                            }

                            openTinyMceEdit(result.document.id, RefID);
                            break;

                        default:
                            ECP.Dialog.Alert(`Editing ${result.document.type} files is not supported.`);
                            break;
                    }
                } else {
                    ECP.Dialog.Alert(result.message);
                }
            }).catch((err) => {
                ECP.Dialog.HideLoading();
                throw err;
            });
        }).catch((err) => {
            ECP.Dialog.HideLoading();
            throw err;
        });
    } else {
        openTinyMceEdit(0, 0);
    }

    function openTinyMceEdit(DocumentID, RefID) {
        let dashboarditemid = "";
        const dashboarditemDom = document.querySelector(`li[document='${DocumentID}']`);
        if (dashboarditemDom) {
            dashboarditemid = dashboarditemDom.getAttribute("id");
        }

        ECP.Tools.Ajax("api?APICommand=Document_HTMLEditDialog", {
            method: "GET"
        }).then((response) => {
            response.json().then((result) => {
                me.UserName = result.username;

                const dialog = ECP.Dialog.ShowDialog(result.title, result.content, {
                    width: 850,
                    height: 600,
                    confirmButtonTitle: result.save,
                    cancelButtonTitle: result.cancel,
                    cancelButtonAction: () => {
                        tinymce.remove();
                        ECP.Dialog.CloseDialog(dialog);
                    },
                    confirmButtonAction: () => {
                        confirmButtonAction();
                    }
                });

                const htmlBody = "<textarea id=ews-document-html-body class=ui-box-size></textarea>";

                dialog.querySelector("#ews-document-html-container").innerHTML = htmlBody;
                dialog.querySelector("#ipt-dashboarditem-id").value = dashboarditemid;

                let UserLanguage = "";
                const UserLanguageElement = document.getElementById("UserLanguage");
                if (UserLanguageElement) {
                    UserLanguage = UserLanguageElement.value;
                }
                EWS.TinymceEdit("#ews-document-html-container", UserLanguage, () => {
                    me.InitLanContent(dashboarditemid, DocumentID, global);
                });

                if (!EC_Fmt.isNull(title)) {
                    dialog.querySelector("#ews-document-title").value = title;
                } else {
                    dialog.querySelector("#ews-document-title").value = "";
                }

                const confirmButtonAction = () => {
                    const title0 = dialog.querySelector("#ews-document-title").value.trim();
                    const content = tinymce.activeEditor.getContent({ format: "raw" });
                    const contentlist = tinymce.get("ews-document-html-container").plugins.language.getLanguageContent(content);

                    if (title0 === "") {
                        ECP.Dialog.Alert(EC_Fmt.Trn("You must enter a title."));

                        return false;
                    }
                    if (content === "" || content === "<p><br data-mce-bogus=1></p>") {
                        ECP.Dialog.Alert("You must enter text to save a text box element");

                        return false;
                    }

                    if (contentlist.length > 0) {
                        // Task 1022996: Saving a text box dashboard widget gives an undefined error if the text box input is more than 400,000 characters long
                        if (contentlist[0].content.length > 390000) {
                            ECP.Dialog.Alert(`Text is longer than the maximum 400000 characters. Value truncated to 400000 characters.`);
                            contentlist[0].content = contentlist[0].content.substring(0, 390000);
                        }
                        me.CreateTinyMceDocument(dashboarditemid, contentlist, RefID, "S3Images", "HTML", title0, (myTinyMce, TinyMceDocumentID, langDocumentId) => {
                            const list = langDocumentId.split(";");

                            for (let i = 0; i < list.length - 1; i++) {
                                const langid = list[i].split(":");
                                tinymce.get("ews-document-html-container").plugins.language.setLanguageDocumentId(langid[0], langid[1]);
                            }

                            tinymce.get("ews-document-html-container").plugins.language.clearLanguageConten();

                            if (!EC_Fmt.isNull(callback)) {
                                tinymce.remove();
                                callback(TinyMceDocumentID, title0);
                                ECP.Dialog.CloseDialog(dialog);
                            }
                        }, global);
                    } else {
                        tinymce.remove();
                        callback(RefID, title0);
                        ECP.Dialog.CloseDialog(dialog);
                    }
                };
            }).catch((err) => {
                ECP.Dialog.HideLoading();
                throw err;
            });
        }).catch((err) => {
            ECP.Dialog.HideLoading();
            throw err;
        });
    }
};

BC_Document.prototype.LoadDocuments = function (dialog, type, search, isImages, documentIds, global) {
    const documentSource = dialog.querySelector("#ews-document-source");
    if (documentSource) {
        if (documentSource.value === "Global") {
            global = true;
        } else {
            global = false;
        }
    }
    const me = this;

    let url = `api?APICommand=Document_GetDocuments&Type=${type}&SearchStr=${search}&Global=${global === true ? "True" : "False"}`;

    if (documentIds) {
        url += `&DocumentIDs=${documentIds}`;
    }

    ECP.Dialog.ShowLoading(undefined, isImages ? "#ews-BC_Image_List-dialog" : "#ews-BC_Document_List-dialog");

    ECP.Tools.Ajax(url, {
        method: "get"
    }).then((response) => {
        response.json().then((results) => {
            let html = "";

            if (results.documents.length > 0) {
                for (let i = 0; i < results.documents.length; i++) {
                    let isCurrent = results.documents[i].document === me.CurrentDocument;

                    if (dialog.selectedResults) {
                        isCurrent = dialog.selectedResults.indexOf(`${results.documents[i].document}`) > -1;
                    }

                    html += `<div class="ews-document-item ${isCurrent ? "ews-document-selecteditem" : ""}"document="${results.documents[i].document}"title="${results.documents[i].name}">`;

                    if (results.documents[i].thumbnail && results.documents[i].thumbnail !== "") {
                        html += `<div class=ews-document-thumbnail style="background-image:url('${results.documents[i].thumbnail}')"></div>`;
                    } else {
                        switch (results.documents[i].type) {
                            case "htm":
                            case "html":
                                html += "<div class=ews-document-thumbnail style=\"background-image:url('Controls/HtmlFile.png')\"></div>";
                                break;

                            case "jpg":
                            case "jpeg":
                            case "bmp":
                            case "gif":
                            case "giff":
                            case "png":
                                html += "<div class=ews-document-thumbnail style=\"background-image:url('Controls/ImageFile.png')\"></div>";
                                break;

                            case "pdf":
                                html += "<div class=ews-document-thumbnail style=\"background-image:url('Controls/PdfFile.png')\"></div>";
                                break;

                            case "flv":
                            case "mp4":
                                html += "<div class=ews-document-thumbnail style=\"background-image:url('Controls/VideoFile.png')\"></div>";
                                break;

                            default:
                                html += "<div class=ews-document-thumbnail style=\"background-image:url('Controls/DefaultFile.png')\"></div>";
                                break;
                        }
                    }

                    html += `<div class=ews-document-title>${results.documents[i].name}</div></div>`;
                }

                if (results.count > 89) {
                    html += "<div class=ews-document-count-message>"
                        + "Not all documents are shown. Search to show more."
                        + "</div>";
                }
            } else {
                html += "<table style=width:100% class=NoPadding>"
                    + "<tr>"
                    + "<td style=text-align:center;padding-top:100px>"
                    + " No documents found."
                    + "</td>"
                    + "</tr>"
                    + "</table>";
            }

            dialog.querySelector("#ews-document-display").innerHTML = html;

            dialog.querySelectorAll(".ews-document-item").forEach((dom) => {
                dom.addEventListener("click", function () {
                    const item = this;
                    const document = item.getAttribute("document");
                    if (isImages) {
                        const selectedResults = dialog.selectedResults;

                        if (item.classList.contains("ews-document-selecteditem")) {
                            item.classList.remove("ews-document-selecteditem");

                            const index = selectedResults.indexOf(document);

                            if (index > -1) {
                                selectedResults.splice(index, 1);
                            }
                        } else {
                            item.classList.add("ews-document-selecteditem");
                            selectedResults.push(document);
                        }
                    } else {
                        const title = item.getAttribute("title");
                        const titleElement = dialog.querySelector("#ews-document-title");
                        if (titleElement) {
                            titleElement.value = title;
                        }

                        const children = item.parentElement.children;
                        for (let i = 0; i < children.length; i++) {
                            children[i].classList.remove("ews-document-selecteditem");
                        }

                        item.classList.add("ews-document-selecteditem");

                        me.CurrentDocument = document;
                    }
                });
            });

            ECP.Dialog.HideLoading();
        }).catch((err) => {
            ECP.Dialog.HideLoading();
            throw err;
        });
    }).catch((err) => {
        ECP.Dialog.HideLoading();
        throw err;
    });
};

BC_Document.prototype.LoadKnowledges = function (dialog, channelId, search) {
    if (search && search !== "") {
        ECP.Dialog.ShowLoading(undefined, "#ews-BC_Knowledge_List-dialog");

        ECP.Tools.Ajax(`api?APICommand=Document_GetKnowledges&KnowledgeChannelID=${channelId}&SearchStr=${search}`, {
            method: "get"
        }).then((response) => {
            response.json().then((results) => {
                const html = results.content;

                dialog.querySelector("#ews-knowledge-display").innerHTML = html;

                document.querySelectorAll("#ews-knowledge-selected-display input[type='checkbox']").forEach((dom) => {
                    // Task 711115: Using the keywords search in a knowledge dashboard item creates an error message
                    const knowledgeDisplayInput = dialog.querySelector(`#ews-knowledge-display input[value='${dom.value}']`);
                    if (dom.checked && knowledgeDisplayInput) {
                        knowledgeDisplayInput.parentNode.parentNode.remove();
                    }
                });

                const knowledgeDisplay = dialog.querySelector("#ews-knowledge-display");
                if (knowledgeDisplay) {
                    knowledgeDisplay.click = null;
                    knowledgeDisplay.querySelectorAll(".ews-knowledge-item-row").forEach((dom) => {
                        dom.addEventListener("click", function (event) {
                            if (event.target.name !== "ews-knowledge-check") {
                                const input = this.querySelector("input[type='checkbox']");
                                if (input) {
                                    input.checked = !input.checked;
                                    const evt = document.createEvent("HTMLEvents");
                                    evt.initEvent("change", false, true);
                                    input.dispatchEvent(evt);
                                }
                            }
                        });
                    });

                    knowledgeDisplay.querySelectorAll("input[type='checkbox']").forEach((dom) => {
                        dom.addEventListener("change", function () {
                            dialog.querySelector("#ews-knowledge-selected-display div").append(this.parentElement.parentElement);
                            this.parentElement.parentElement.addEventListener("click", function (event) {
                                if (event.target.name !== "ews-knowledge-check") {
                                    const input = this.querySelector("input[type='checkbox']");
                                    if (input) {
                                        input.checked = false;
                                        const evt = document.createEvent("HTMLEvents");
                                        evt.initEvent("change", false, true);
                                        input.dispatchEvent(evt);
                                    }
                                }
                            });

                            this.addEventListener("change", function () {
                                // Task 994768: The Knowledges widget search issue
                                if (!this.checked) {
                                    const displayDiv = dialog.querySelector("#ews-knowledge-display div");
                                    if (displayDiv) {
                                        displayDiv.prepend(this.parentElement.parentElement);
                                    } else {
                                        this.parentElement.parentElement.remove();
                                    }
                                }
                            });
                        });
                    });
                }

                ECP.Dialog.HideLoading();
            }).catch((err) => {
                ECP.Dialog.HideLoading();
                throw err;
            });
        }).catch((err) => {
            ECP.Dialog.HideLoading();
            throw err;
        });
    }
};

BC_Document.prototype.Save = function (document, type, body, title, callback) {
    const data = new FormData();

    data.append("Type", type);
    data.append("DocumentID", document);
    data.append("Title", title);
    data.append("Body", body);

    ECP.Tools.Ajax("api?APICommand=Document_SaveContent", {
        method: "POST",
        body: data
    }).then((response) => {
        response.json().then((result) => {
            ECP.Dialog.HideLoading();
            if (result.status === "success") {
                if (!EC_Fmt.isNull(callback)) {
                    callback(result.title);
                }
            } else {
                ECP.Dialog.Alert(result.message);
            }
        }).catch((err) => {
            ECP.Dialog.HideLoading();
            throw err;
        });
    }).catch((err) => {
        ECP.Dialog.HideLoading();
        throw err;
    });
};

BC_Document.prototype.Select = function (types, callback, document, title, showDownload, global) {
    const me = this;
    ECP.Tools.Ajax("api?APICommand=Document_DocumentListDialog", {
        method: "GET"
    }).then((response) => {
        response.json().then((result) => {
            me.UserName = result.username;

            const dialog = ECP.Dialog.ShowDialog(result.title, result.content, {
                width: 715,
                // Task 1061449: Run Test Case 4691 Fail
                height: 680,
                confirmButtonTitle: result.select,
                cancelButtonTitle: result.cancel,
                confirmButtonAction: () => {
                    let documentTitle = "";
                    if (dialog.querySelector("#ews-document-title")) {
                        documentTitle = dialog.querySelector("#ews-document-title").value;
                    }
                    const currentDocument = me.CurrentDocument;

                    let documentType = "";
                    if (dialog.querySelector("#ews-document-type")) {
                        documentType = dialog.querySelector("#ews-document-type").value;
                    }

                    let showDownloadButton = "";
                    if (showdownloadbutton) {
                        showDownloadButton = showdownloadbutton.value;
                    }

                    if (currentDocument === "") {
                        ECP.Dialog.Alert(EC_Fmt.Trn("You must select a document."));
                        return;
                    }

                    if (documentTitle === "") {
                        ECP.Dialog.Alert(EC_Fmt.Trn("You must enter a title."));
                        return;
                    }

                    if (!EC_Fmt.isNull(callback)) {
                        // Task 743363: Cannot Update Title of Documents Dashboard Widget
                        callback(currentDocument, documentTitle, documentType, showDownloadButton);
                    }
                },
                cancelButtonAction: () => {
                    me.CurrentDocument = "";
                }
            });

            dialog.querySelector(".ecp-dialog-footer").prepend(EC_Fmt.HtmlStrToElement(`<div id=ews-manage-button class=ecp-dialog-cancel-button>${result.manage}</div>`));

            const manageButton = dialog.querySelector("#ews-manage-button");
            if (manageButton) {
                manageButton.addEventListener("click", () => {
                    window.open(`Home?DashboardID=${ECP.CommonDashboards.TableView}&TableName=${global ? "GlobalDocuments" : "Documents"}`);
                });
            }

            let html = "";

            const typeArr = types.split(",");

            for (let i = 0; i < typeArr.length; i++) {
                html += `<option value="${typeArr[i]}">${typeArr[i]}</option>`;
            }

            const type = dialog.querySelector("#ews-document-type");
            if (type) {
                type.innerHTML = html;
            }

            const search = dialog.querySelector("#ews-document-search");
            if (search) {
                search.value = "";
            }

            const display = dialog.querySelector("#ews-document-display");
            if (display) {
                display.innerHTML = "";
            }

            if (title && dialog.querySelector("#ews-document-title")) {
                dialog.querySelector("#ews-document-title").value = title;
            }

            const showdownloadbutton = dialog.querySelector("#ews-document-showdownloadbutton");
            if (showdownloadbutton) {
                if (showDownload === "true") {
                    showdownloadbutton.value = "true";
                } else {
                    showdownloadbutton.value = "false";
                }
            }

            if (document) {
                ECP.Tools.Ajax(`api?APICommand=Document_GetDocument&DocumentID=${document}&Global=${global ? "True" : "False"}`, {
                    method: "GET"
                }).then((GetDocumentResponse) => {
                    GetDocumentResponse.json().then((GetDocumentResult) => {
                        if (GetDocumentResult.status === "success") {
                            me.CurrentDocument = document;
                            dialog.querySelector("#ews-document-type").value = GetDocumentResult.document.type;

                            me.LoadDocuments(dialog, GetDocumentResult.document.type, dialog.querySelector("#ews-document-search").value, undefined, document, global);
                        } else {
                            ECP.Dialog.Alert(GetDocumentResult.message);
                        }
                    });
                });
            }

            if (search) {
                search.addEventListener("keydown", (event) => {
                    if (event.key === "Enter") {
                        me.LoadDocuments(dialog, dialog.querySelector("#ews-document-type").value, dialog.querySelector("#ews-document-search").value, null, null, global);
                        return false;
                    }
                    return true;
                });
            }

            const searchButton = dialog.querySelector("#ews-document-search-button");
            if (searchButton) {
                searchButton.click = null;
                searchButton.addEventListener("click", () => {
                    me.LoadDocuments(dialog, dialog.querySelector("#ews-document-type").value, dialog.querySelector("#ews-document-search").value, null, null, global);
                });
            }
        });
    });
};

BC_Document.prototype.SelectImages = function (types, callback, title, documents, global, itemName, imageSource) {
    const me = this;
    ECP.Tools.Ajax(`api?APICommand=Document_DocumentListDialog`, {
        method: "GET"
    }).then((response) => {
        response.json().then((result) => {
            me.UserName = result.username;

            const dialog = ECP.Dialog.ShowDialog(result.title, result.content, {
                width: 715,
                // Task 1061449: Run Test Case 4691 Fail
                height: 670,
                confirmButtonTitle: result.select,
                cancelButtonTitle: result.cancel,
                confirmButtonAction: (modalContainer) => {
                    let DocumentListTitle = "";
                    const titleDom = dialog.querySelector("#ews-document-title");
                    if (titleDom) {
                        DocumentListTitle = titleDom.value;
                    }

                    const selectedResults = dialog.selectedResults;

                    if (selectedResults.length === 0) {
                        ECP.Dialog.Alert(EC_Fmt.Trn("You must select an image."));
                        modalContainer.style.display = "block";
                        return false;
                    }

                    if (DocumentListTitle === "") {
                        ECP.Dialog.Alert(EC_Fmt.Trn("You must enter a title."));
                        modalContainer.style.display = "block";
                        return false;
                    }

                    if (!EC_Fmt.isNull(callback)) {
                        if (dialog.querySelector("#ews-document-source")) {
                            callback(selectedResults, DocumentListTitle, dialog.querySelector("#ews-document-source").value);
                        } else {
                            callback(selectedResults, DocumentListTitle);
                        }
                    }
                    ECP.Dialog.CloseDialog(dialog);
                    return true;
                }
            });

            dialog.querySelector(".ecp-dialog-footer").prepend(EC_Fmt.HtmlStrToElement(`<div id=ews-manage-button class=ecp-dialog-cancel-button>${result.manage}</div>`));

            const settings = dialog.querySelector("#ews-document-settings");
            if (settings) {
                settings.remove();
            }

            const boxSize = dialog.querySelector(".ews-edit-form .ui-box-size");
            if (boxSize) {
                boxSize.style.paddingTop = "110px";
            }

            let html = "";
            const arr = types.split(",");
            for (let i = 0, len = arr.length; i < len; i++) {
                html += `<option value='${arr[i]}'>${arr[i]}</option>`;
            }

            const typeDom = dialog.querySelector("#ews-document-type");
            if (typeDom) {
                typeDom.innerHTML = html;
            }

            // Task 717530: add Image Source
            if (itemName === "NewBanner") {
                const parent = typeDom.parentNode;

                const newElement = document.createElement("td");
                newElement.innerHTML = "Image Source";

                const newElementOption = document.createElement("td");
                let str = "<select id='ews-document-source'>";
                if (global) {
                    str += "<option value='Global'>Global documents</option>";
                }
                str += "<option value='Local'>Local documents</option></select>";
                newElementOption.innerHTML = str;

                parent.parentNode.insertBefore(newElementOption, parent.nextSibling);
                parent.parentNode.insertBefore(newElement, parent.nextSibling);

                const sourceType = dialog.querySelector("#ews-document-source");
                if (imageSource) {
                    sourceType.value = imageSource;
                } else if (global) {
                    // task 909457: Document Dashboard Item changed from referencing DocumentID to Global Document ID; wrong document being shown
                    sourceType.value = "Global";
                    dialog.querySelector("#ews-document-source").value = "Global";
                }
                sourceType.addEventListener("change", () => {
                    dialog.selectedResults = [];
                    dialog.querySelector("#ews-document-display").innerHTML = "";
                });
            }
            const search = dialog.querySelector("#ews-document-search");
            if (search) {
                search.value = "";
                dialog.addEventListener("keydown", (event) => {
                    if (event.key === "Enter") {
                        me.LoadDocuments(dialog, dialog.querySelector("#ews-document-type").value, dialog.querySelector("#ews-document-search").value, true, "", global);
                        event.stopPropagation();
                        event.preventDefault();
                    }
                    return true;
                });
            }

            const display = dialog.querySelector("#ews-document-display");
            if (display) {
                display.innerHTML = "";
            }

            if (title && dialog.querySelector("#ews-document-title")) {
                dialog.querySelector("#ews-document-title").value = title;
            }

            dialog.selectedResults = [];

            if (documents) {
                dialog.selectedResults = documents.split("^");
                let typleValue = "";
                if (typeDom) {
                    typleValue = typeDom.value;
                }

                let searchValue = "";
                if (searchValue) {
                    searchValue = search.value;
                }
                me.LoadDocuments(dialog, typleValue, searchValue, true, documents, global);
            }

            const manageButton = dialog.querySelector("#ews-manage-button");
            if (manageButton) {
                manageButton.click = null;
                manageButton.addEventListener("click", () => {
                    if (dialog.querySelector("#ews-document-source")) {
                        if (dialog.querySelector("#ews-document-source").value === "Global") {
                            global = true;
                        } else {
                            global = false;
                        }
                    }
                    window.open(`Home?DashboardID=${ECP.CommonDashboards.TableView}&TableName=${global ? "GlobalDocuments" : "Documents"}`);
                });
            }

            const searchButton = dialog.querySelector("#ews-document-search-button");
            if (searchButton) {
                searchButton.addEventListener("click", () => {
                    let typeValue = "";
                    if (typeDom) {
                        typeValue = typeDom.value;
                    }

                    let searchValue = "";
                    if (search) {
                        searchValue = search.value;
                    }
                    me.LoadDocuments(dialog, typeValue, searchValue, true, "", global);
                });
            }

            dialog.querySelectorAll("#ews-document-display .ews-document-item").forEach((dom) => {
                dom.addEventListener("click", function () {
                    const item = this;
                    const document = item.getAttribute("document");
                    const selectedResults = dialog.selectedResults;

                    if (item.classList.contains("ews-document-selecteditem")) {
                        item.classList.remove("ews-document-selecteditem");

                        const index = selectedResults.indexOf(document);

                        if (index > -1) {
                            selectedResults.splice(index, 1);
                        }
                    } else {
                        item.classList.add("ews-document-selecteditem");
                        selectedResults.push(document);
                    }
                });
            });
        });
    });
};

BC_Document.prototype.KnowledgeSelect = function (callback, knowledgeChannelId, knowledgeIds, title) {
    const me = this;
    ECP.Tools.Ajax(`api?APICommand=Document_KnowledgeListDialog`, {
        method: "GET"
    }).then((response) => {
        response.json().then((result) => {
            me.username = result.username;

            const dialog = ECP.Dialog.ShowDialog(result.title, result.content, {
                width: 715,
                // Task 1061449: Run Test Case 4691 Fail
                height: 670,
                confirmButtonTitle: result.select,
                cancelButtonTitle: result.cancel,
                cancelButtonAction: () => {
                    tinymce.remove();
                    ECP.Dialog.CloseDialog(dialog);
                },
                confirmButtonAction: () => {
                    confirmButtonAction();
                }
            });

            const confirmButtonAction = () => {
                const knowledgeTitle = dialog.querySelector("#ews-knowledge-title").value;
                const channel = dialog.querySelector("#ews-knowledge-channel").value;
                const selectKnowledgeIds = [];

                // Task 1005600: Adding Knowledge in Dashboard Knowledge Widget does not allow de-selection of knowledge and keeps previously-selected knowledge selected.
                dialog.querySelectorAll("#ews-knowledge-selected-display input[type='checkbox']").forEach((dom) => {
                    if (dom.checked) {
                        selectKnowledgeIds.push(dom.value);
                    }
                });

                if (selectKnowledgeIds.length === 0) {
                    ECP.Dialog.Alert(EC_Fmt.Trn("You must select a knowledge."));
                    return;
                }

                if (knowledgeTitle === "") {
                    ECP.Dialog.Alert(EC_Fmt.Trn("You must enter a title."));
                    return;
                }

                if (!EC_Fmt.isNull(callback)) {
                    ECP.Dialog.CloseDialog(dialog);
                    callback(selectKnowledgeIds, knowledgeTitle, channel);
                }
            };

            const channel = dialog.querySelector("#ews-knowledge-channel");
            if (channel) {
                channel.addEventListener("change", () => {
                    document.querySelector("#ews-knowledge-selected-display > div").innerHTML = "";
                    me.LoadKnowledges(dialog, dialog.querySelector("#ews-knowledge-channel").value, dialog.querySelector("#ews-knowledge-search").value);
                });
            }

            const search = dialog.querySelector("#ews-knowledge-search");
            if (search) {
                search.addEventListener("keydown", (event) => {
                    if (event.key === "Enter") {
                        me.LoadKnowledges(dialog, dialog.querySelector("#ews-knowledge-channel").value, dialog.querySelector("#ews-knowledge-search").value);
                        return false;
                    }
                    return true;
                });
            }

            const searchButton = dialog.querySelector("#ews-knowledge-search-button");
            if (searchButton) {
                searchButton.addEventListener("click", () => {
                    me.LoadKnowledges(dialog, dialog.querySelector("#ews-knowledge-channel").value, dialog.querySelector("#ews-knowledge-search").value);
                });
            }

            if (title) {
                dialog.querySelector("#ews-knowledge-title").value = title;
            }

            if (knowledgeChannelId) {
                dialog.querySelector("#ews-knowledge-channel").value = knowledgeChannelId;
            }

            if (knowledgeIds) {
                ECP.Dialog.ShowLoading(undefined, "#ews-BC_Knowledge_List-dialog");

                ECP.Tools.Ajax(`api?APICommand=Document_GetKnowledges&KnowledgeChannelID=${knowledgeChannelId}&KnowledgeIDs=${knowledgeIds}&NotShowChildren=NotShowChildren`, {
                    method: "GET"
                }).then((knowledgeResponse) => {
                    knowledgeResponse.json().then((results) => {
                        dialog.querySelector("#ews-knowledge-selected-display").innerHTML = results.content;
                        dialog.querySelectorAll("#ews-knowledge-selected-display input[type='checkbox']").forEach((dom) => {
                            dom.checked = true;
                        });

                        const selectedDisplay = dialog.querySelector("#ews-knowledge-selected-display");
                        if (selectedDisplay) {
                            selectedDisplay.click = null;
                            selectedDisplay.querySelectorAll(".ews-knowledge-item-row").forEach((dom) => {
                                dom.addEventListener("click", function (event) {
                                    if (event.target.name !== "ews-knowledge-check") {
                                        const input = this.querySelector("input[type='checkbox']");
                                        if (input) {
                                            input.checked = false;
                                            const evt = document.createEvent("HTMLEvents");
                                            evt.initEvent("change", false, true);
                                            input.dispatchEvent(evt);
                                        }
                                    }
                                });
                            });

                            // Task 994768: The Knowledges widget search issue
                            selectedDisplay.querySelectorAll("input[type='checkbox']").forEach((dom) => {
                                dom.addEventListener("change", function () {
                                    if (dialog.querySelector("#ews-knowledge-display div")) {
                                        function turnDown() {
                                            dialog.querySelector("#ews-knowledge-selected-display div").append(this.parentElement.parentElement);
                                            const _this = EC_Fmt.RemoveAllEventListeners(this);
                                            _this.addEventListener("change", () => {
                                                if (!_this.checked) {
                                                    if (dialog.querySelector("#ews-knowledge-display div")) {
                                                        dialog.querySelector("#ews-knowledge-display div").prepend(_this.parentElement.parentElement);
                                                        _this.addEventListener("change", turnDown);
                                                    } else {
                                                        _this.parentElement.parentElement.remove();
                                                    }
                                                }
                                            });
                                        }
                                        this.addEventListener("change", turnDown);
                                        dialog.querySelector("#ews-knowledge-display div").prepend(this.parentElement.parentElement);
                                    } else {
                                        this.parentElement.parentElement.remove();
                                    }
                                });
                            });
                        }
                        ECP.Dialog.HideLoading();
                    });
                }).catch((err) => {
                    ECP.Dialog.HideLoading();
                    throw err;
                });
            }
        });
    });
};

BC_Document.prototype.KnowledgeReports = function (callback, knowledgeChannelId, viewCount, title, knowledgeGroups, knowledgeGroupsNames, createdBy, documentType, timeCreatedPeriod) {
    const me = this;
    ECP.Tools.Ajax("api?APICommand=Document_KnowledgeReportsDialog", {
        method: "GET"
    }).then((response) => {
        response.json().then((result) => {
            me.username = result.username;
            const dialog = ECP.Dialog.ShowDialog(result.title, result.content, {
                width: 567,
                // Task 1061449: Run Test Case 4691 Fail
                height: 460,
                confirmButtonTitle: result.select,
                cancelButtonTitle: result.cancel,
                confirmButtonAction: () => {
                    const getVal = function (selecter) {
                        const dom = dialog.querySelector(selecter);
                        if (dom) {
                            return dom.value;
                        }
                        return "";
                    };

                    const reportsTitle = getVal("#ews-knowledge-reports-title");
                    const channel = getVal("#ews-knowledge-reports-channel");
                    const knowledgeTimeCreatedPeriod = getVal("#ews-knowledge-reports-time-created-period");
                    const knowledgeViewCount = getVal("#ews-knowledge-reports-view-count");
                    const knowledgeCreatedBy = getVal("#CreatedByHidden");
                    const knowledgeDocumentType = getVal("#ews-knowledge-reports-document-type");
                    const knowledgeGroupsHidden = getVal("#KnowledgeGroupsHidden");
                    let knowledge_GroupsNames = "";

                    if (dialog.querySelector("#KnowledgeGroupsInput")) {
                        knowledge_GroupsNames = dialog.querySelector("#KnowledgeGroupsInput").getAttribute("encdisplayvalue");
                    }

                    if (reportsTitle === "") {
                        ECP.Dialog.Alert(EC_Fmt.Trn("You must enter a title."));
                        return;
                    }

                    if (!EC_Fmt.isNull(callback)) {
                        callback(reportsTitle, channel, knowledgeTimeCreatedPeriod, knowledgeViewCount, knowledgeGroupsHidden, knowledge_GroupsNames, knowledgeCreatedBy, knowledgeDocumentType);
                    }
                    ECP.Dialog.CloseDialog(dialog);
                }
            });
            new ECP.HTML.AjaxInput(document.getElementById("CreatedByInput"));
            new ECP.HTML.AjaxInput(document.getElementById("KnowledgeGroupsInput"));

            const channel = dialog.querySelector("#ews-knowledge-reports-channel");
            if (channel) {
                channel.addEventListener("change", () => {
                    const value = document.getElementById("ews-knowledge-reports-channel").value;
                    const distributorDom = document.querySelector(`#ews-knowledge-reports-channel option[value='${value}']`);
                    let distributor = "";
                    if (distributorDom) {
                        distributor = distributorDom.getAttribute("distributor");
                    }

                    if (distributor.indexOf("Support") !== -1) {
                        const KnowledgeReportCreatedBy = document.getElementById("KnowledgeReportCreatedBy");
                        if (KnowledgeReportCreatedBy) {
                            KnowledgeReportCreatedBy.style.display = "none";
                        }
                        const CreatedByHidden = document.getElementById("CreatedByHidden");
                        if (CreatedByHidden) {
                            CreatedByHidden.value = "";
                        }
                        const CreatedByInput = document.getElementById("CreatedByInput");
                        if (CreatedByInput) {
                            CreatedByInput.value = "";
                        }
                        const KnowledgeGroupsHidden = document.getElementById("KnowledgeGroupsHidden");
                        if (KnowledgeGroupsHidden) {
                            KnowledgeGroupsHidden.value = "";
                        }
                        const KnowledgeGroupsInput = document.getElementById("KnowledgeGroupsInput");
                        if (KnowledgeGroupsInput) {
                            KnowledgeGroupsInput.value = "System";
                            KnowledgeGroupsInput.setAttribute("disabled", "disabled");
                        }
                    } else {
                        const KnowledgeReportCreatedBy = document.getElementById("KnowledgeReportCreatedBy");
                        if (KnowledgeReportCreatedBy) {
                            KnowledgeReportCreatedBy.style.display = "block";
                        }
                        const KnowledgeGroupsInput = document.getElementById("KnowledgeGroupsInput");
                        if (KnowledgeGroupsInput) {
                            KnowledgeGroupsInput.value = "";
                            KnowledgeGroupsInput.removeAttribute("disabled");
                        }
                    }
                });
                if (knowledgeChannelId) {
                    channel.value = knowledgeChannelId;
                }

                const evt = document.createEvent("HTMLEvents");
                evt.initEvent("change", false, true);
                channel.dispatchEvent(evt);
            }

            if (title && dialog.querySelector("#ews-knowledge-reports-title")) {
                dialog.querySelector("#ews-knowledge-reports-title").value = title;
            }

            if (viewCount && dialog.querySelector("#ews-knowledge-reports-view-count")) {
                dialog.querySelector("#ews-knowledge-reports-view-count").value = viewCount;
            }

            if (knowledgeGroups && dialog.querySelector("#KnowledgeGroupsHidden")) {
                dialog.querySelector("#KnowledgeGroupsHidden").value = knowledgeGroups;
            }

            if (knowledgeGroups) {
                const KnowledgeGroupsHidden = dialog.querySelector("#KnowledgeGroupsHidden");
                const KnowledgeGroupsInput = dialog.querySelector("#KnowledgeGroupsInput");
                if (knowledgeGroups.indexOf("^") !== -1) {
                    if (KnowledgeGroupsHidden) {
                        KnowledgeGroupsHidden.setAttribute("encselarray", knowledgeGroups);
                        KnowledgeGroupsHidden.setAttribute("value", knowledgeGroups);
                    }

                    if (KnowledgeGroupsInput) {
                        KnowledgeGroupsInput.value = "Multiple...";
                        KnowledgeGroupsInput.classList.add("Info");
                        KnowledgeGroupsInput.setAttribute("encdisplayvalue", knowledgeGroupsNames);
                        KnowledgeGroupsInput.setAttribute("encselarray", knowledgeGroupsNames);
                    }
                } else {
                    if (KnowledgeGroupsHidden) {
                        KnowledgeGroupsHidden.setAttribute("value", knowledgeGroups);
                    }
                    if (KnowledgeGroupsInput) {
                        KnowledgeGroupsInput.value = knowledgeGroupsNames;
                    }
                }
            }

            if (createdBy) {
                const CreatedByHidden = document.getElementById("CreatedByHidden");
                const CreatedByInput = document.getElementById("CreatedByInput");

                if (createdBy.indexOf("^") !== -1) {
                    if (CreatedByHidden) {
                        CreatedByHidden.setAttribute("encselarray", createdBy);
                        CreatedByHidden.setAttribute("value", createdBy);
                    }

                    if (CreatedByInput) {
                        CreatedByInput.value = "Multiple...";
                        CreatedByInput.classList.add("Info");
                        CreatedByInput.setAttribute("encdisplayvalue", createdBy);
                        CreatedByInput.setAttribute("encselarray", createdBy);
                    }
                } else {
                    if (CreatedByHidden) {
                        CreatedByHidden.setAttribute("value", createdBy);
                    }

                    if (CreatedByInput) {
                        CreatedByInput.value = createdBy;
                    }
                }
            }

            if (documentType && dialog.querySelector("#ews-knowledge-reports-document-type")) {
                dialog.querySelector("#ews-knowledge-reports-document-type").value = documentType;
            }

            if (timeCreatedPeriod && dialog.querySelector("#ews-knowledge-reports-time-created-period")) {
                dialog.querySelector("#ews-knowledge-reports-time-created-period").value = timeCreatedPeriod;
            }
        });
    });
};

BC_Document.prototype.InitLanContent = function (dashboardItemId, documentID, globla) {
    if (documentID && documentID > 0) {
        ECP.Tools.Ajax(`api?APICommand=Document_GetAllDocuments&DocumentID=${documentID}&Global=${globla ? "True" : "False"}`, {
            method: "GET"
        }).then((response) => {
            response.json().then((result) => {
                for (const i in result.documents) {
                    const item = result.documents[i];
                    tinymce.get("ews-document-html-container").plugins.language.setLanguageContent(item.language, item.content, item.documentid);

                    if (item.documentid === documentID) {
                        if (item.language === "") {
                            item.language = "EN";
                        }

                        tinymce.get("ews-document-html-container").plugins.language.currentLanguage = item.language;
                        tinymce.activeEditor.setContent(item.content, { format: "raw" });
                        const globe = document.querySelector(".mce-widget .ews-icon-globe");
                        if (globe) {
                            globe.parentElement.innerHTML = `<i class=ews-icon-globe></i>${tinymce.get("ews-document-html-container").plugins.language.getCurrentLanguage(item.language)}<i class=mce-caret></i>`;
                        }
                    }
                }
            });
        });
    } else {
        tinymce.get("ews-document-html-container").plugins.language.setLanguageContent("EN", "", 0);

        tinymce.get("ews-document-html-container").plugins.language.currentLanguage = "EN";
        tinymce.activeEditor.setContent("", { format: "raw" });
        const globe = document.querySelector(".mce-widget .ews-icon-globe");
        if (globe) {
            globe.parentElement.innerHTML = `<i class=ews-icon-globe></i>${tinymce.get("ews-document-html-container").plugins.language.getCurrentLanguage("EN")}<i class=mce-caret></i>`;
        }
    }
};

(function (EWS) {
    // eslint-disable-next-line no-shadow
    EWS.Ready((EWS) => {
        // Task 606021: CRM - Remove 3rd party JS/CSS libraries (including jQuery) from Encompass by 1/1/2020
        EWS.Document = new BC_Document(EWS);
    });
}(EWS));
